import { Share2, Twitter, Facebook, Linkedin, MessageCircle, Copy, Check } from "lucide-react";
import { useState } from "react";
import { cn } from "@/lib/utils";
import { toast } from "@/hooks/use-toast";

interface SocialShareProps {
  title: string;
  url: string;
  className?: string;
}

export const SocialShare = ({ title, url, className }: SocialShareProps) => {
  const [copied, setCopied] = useState(false);
  
  const shareUrl = typeof window !== 'undefined' ? window.location.origin + url : url;
  const encodedUrl = encodeURIComponent(shareUrl);
  const encodedTitle = encodeURIComponent(title);

  const shareLinks = {
    twitter: `https://twitter.com/intent/tweet?text=${encodedTitle}&url=${encodedUrl}`,
    facebook: `https://www.facebook.com/sharer/sharer.php?u=${encodedUrl}`,
    linkedin: `https://www.linkedin.com/sharing/share-offsite/?url=${encodedUrl}`,
    whatsapp: `https://wa.me/?text=${encodedTitle}%20${encodedUrl}`,
  };

  const handleCopyLink = async () => {
    try {
      await navigator.clipboard.writeText(shareUrl);
      setCopied(true);
      toast({
        title: "تم النسخ!",
        description: "تم نسخ رابط المقال بنجاح",
      });
      setTimeout(() => setCopied(false), 2000);
    } catch (err) {
      toast({
        title: "خطأ",
        description: "فشل نسخ الرابط",
        variant: "destructive",
      });
    }
  };

  return (
    <div className={cn("flex items-center gap-3 flex-wrap", className)}>
      <div className="flex items-center gap-2 text-foreground/70">
        <Share2 className="w-5 h-5" />
        <span className="text-sm font-medium">شارك المقال:</span>
      </div>
      
      <div className="flex items-center gap-2">
        <a
          href={shareLinks.twitter}
          target="_blank"
          rel="noopener noreferrer"
          className="p-2 rounded-lg border border-border bg-background hover:bg-accent hover:text-sand transition-all duration-300 hover:scale-110"
          aria-label="Share on Twitter"
        >
          <Twitter className="w-5 h-5" />
        </a>
        
        <a
          href={shareLinks.facebook}
          target="_blank"
          rel="noopener noreferrer"
          className="p-2 rounded-lg border border-border bg-background hover:bg-accent hover:text-sand transition-all duration-300 hover:scale-110"
          aria-label="Share on Facebook"
        >
          <Facebook className="w-5 h-5" />
        </a>
        
        <a
          href={shareLinks.linkedin}
          target="_blank"
          rel="noopener noreferrer"
          className="p-2 rounded-lg border border-border bg-background hover:bg-accent hover:text-sand transition-all duration-300 hover:scale-110"
          aria-label="Share on LinkedIn"
        >
          <Linkedin className="w-5 h-5" />
        </a>
        
        <a
          href={shareLinks.whatsapp}
          target="_blank"
          rel="noopener noreferrer"
          className="p-2 rounded-lg border border-border bg-background hover:bg-accent hover:text-sand transition-all duration-300 hover:scale-110"
          aria-label="Share on WhatsApp"
        >
          <MessageCircle className="w-5 h-5" />
        </a>
        
        <button
          onClick={handleCopyLink}
          className="p-2 rounded-lg border border-border bg-background hover:bg-accent hover:text-sand transition-all duration-300 hover:scale-110"
          aria-label="Copy link"
        >
          {copied ? <Check className="w-5 h-5" /> : <Copy className="w-5 h-5" />}
        </button>
      </div>
    </div>
  );
};
